import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "moment";
import "moment/locale/ru";
import Maska from 'maska'

import localStorage from '@/plugins/localStorage'
import ws from "@/plugins/websocket"
import {AuthTokenExpiredError} from '@/plugins/errors.js'
import connectionStorage from '@/plugins/connectionStorage'

import Ripple from './directives/ripple/ripple'
import './directives/ripple/ripple.css'

import 'bootstrap/dist/css/bootstrap-reboot.min.css'
import 'bootstrap/dist/css/bootstrap-grid.min.css'

import './assets/fonts/roboto/style.css'
import './assets/fonts/icomoon/style.css'
import './assets/themes/dark.scss'
import './assets/themes/dark.v2.scss'
import './assets/themes/light.scss'
import './assets/themes/light.v2.scss'
import './assets/styles/default.scss'
import './assets/styles/forms.scss'
import './assets/styles/typography.scss'
import './assets/styles/buttons.scss'


//асинхронная инициализация, чтобы можно было получить параметры из приложения синхронно
//до старта приложения
let init = async () => {

    //восстанавливаем текущее подключение
    let key = await localStorage.get("current_connection");
    let arConnections = await localStorage.get("connections");
    if (
        key !== null &&
        arConnections !== null &&
        arConnections[key]
    ) {
        //сохраняем список подключений в текущем состоянии
        connectionStorage.setConnections(arConnections);
        //сохраням в текущем состоянии
        connectionStorage.setCurrentConnection(key);

        //загрузим настройки клиента (ожидаем, чтобы загрузился в обязательном порядке список доступных сервисов)
        try {
            await store.dispatch("loadClientSettings");
        } catch (e) {

            //если не ошибка устаревания токена
            if(!(e instanceof AuthTokenExpiredError)) {
                alert(e.message);
                return;
            }
            
        }

        //после выполнения запроса loadClientSettings авторизация может сброситься
        if(connectionStorage.isAuthorized()) {
            //загрузим профиль пользователя
            store.dispatch("loadUserData");
            //регистрируем подключение по вебсокету
            ws.register();
        }

        
    } else {
        //очищаем подключения
        connectionStorage.setConnections({});
        connectionStorage.setCurrentConnection(0);
    }

    //начать слушать события обновления от других вкладок
    connectionStorage.startListenAuthUpdate();

    //восстанавливаем тему
    let theme = await localStorage.get("theme");
    if (theme == null) {
        theme = "dark";
    }
    store.commit("setTheme", theme);

    const app = createApp(App)

    //плагин ряби на кнопках
    Ripple.color = 'rgba(100, 100, 100, 0.15)';
    app.directive('ripple', Ripple);

    app.use(store).use(router).use(Maska).mount('#app')
}

init();
